import { createApi } from '@reduxjs/toolkit/query/react';

import { toUser } from '@/features/auth/toUser';
import { User } from '@/features/auth/types';
import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery({ baseUrl: '' }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    // The cookie is HttpOnly, so this endpoint is the SPA's only window into the session.
    getCurrentUser: builder.query<User, void>({
      query: () => ({
        url: '/user',
      }),
      transformResponse: toUser,
    }),
  }),
});

export const { useLazyGetCurrentUserQuery } = authApi;
